import React from 'react'

import {TwBackground, TwChatReaction, TwCount, TwEmoji} from './containers'
import {ReactionProps} from './types'

export const Reaction = React.forwardRef<HTMLDivElement, ReactionProps>(
  ({value, count, onClick, reacted, hint, browser}, ref) => (
    <TwChatReaction ref={ref} onClick={onClick} content={hint ?? null}>
      <TwBackground $reacted={reacted} />
      <TwEmoji $browser={browser} value={value} />
      <TwCount $reacted={reacted}>{count}</TwCount>
    </TwChatReaction>
  )
)
